import React, { useState } from 'react';
import Icon from '../AppIcon';
import Button from './Button';
import Image from '../AppImage';

const UserProfilePopup = ({ userName, userRole, onClose, isOpen, userEmail, onLogout }) => {
  const [showChangeUser, setShowChangeUser] = useState(false);

  const roleLabels = {
    admin: 'مدير النظام',
    property_manager: 'مدير الخصائص',
    contract_specialist: 'أخصائي العقود',
    client_manager: 'مدير العملاء',
  };

  const handleChangeUser = async () => {
    try {
      // Changing user means logging out current user and going to login screen
      await onLogout?.();
      onClose();
    } catch (error) {
      console.error('Error changing user:', error);
      alert('حدث خطأ أثناء تغيير المستخدم');
    }
  };

  const handleLogout = async () => {
    try {
      await onLogout?.();
      onClose();
    } catch (error) {
      console.error('Error logging out:', error);
      alert('حدث خطأ أثناء تسجيل الخروج');
    }
  };

  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black/20 z-40"
        onClick={onClose}
      />
      {/* Popup */}
      <div className="fixed top-20 left-4 md:left-8 bg-background border border-border rounded-xl shadow-2xl z-50 w-80 overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-br from-primary/20 to-accent/20 p-4 border-b border-border">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-primary to-accent flex items-center justify-center">
                <Icon name="User" size={24} color="white" />
              </div>
              <div>
                <h3 className="text-lg font-bold text-foreground">{userName}</h3>
                <span className="text-xs text-muted-foreground">{roleLabels?.[userRole]}</span>
              </div>
            </div>
            <button
              onClick={onClose}
              className="p-1 hover:bg-muted/50 rounded-lg transition-colors"
            >
              <Icon name="X" size={18} color="#888" />
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="p-4 space-y-3">
          {!showChangeUser ? (
            <>
              {/* User Info */}
              <div className="space-y-2 pb-3 border-b border-border">
                <div className="flex items-center gap-2 text-sm">
                  <Icon name="Mail" size={16} color="#DAA520" />
                  <span className="text-muted-foreground text-left" dir="ltr">{userEmail || 'user@arddjo.com'}</span>
                </div>
                <div className="flex items-center gap-2 text-sm">
                  <Icon name="Phone" size={16} color="#DAA520" />
                  <span className="text-muted-foreground text-left" dir="ltr">+962 79 123 4567</span>
                </div>
                <div className="flex items-center gap-2 text-sm">
                  <Icon name="Clock" size={16} color="#DAA520" />
                  <span className="text-muted-foreground">آخر دخول: اليوم <span dir="ltr" className="text-left">08:03</span></span>
                </div>
              </div>

              {/* Actions */}
              <div className="space-y-2">
                <Button
                  onClick={() => setShowChangeUser(true)}
                  className="w-full justify-start gap-2 bg-primary/10 hover:bg-primary/20 text-foreground"
                  variant="ghost"
                >
                  <Icon name="UserCog" size={18} color="#DAA520" />
                  <span>تغيير المستخدم</span>
                </Button>

                <Button
                  onClick={() => alert('فتح إعدادات الملف الشخصي')}
                  className="w-full justify-start gap-2 hover:bg-muted"
                  variant="ghost"
                >
                  <Icon name="Settings" size={18} color="#888" />
                  <span>إعدادات الحساب</span>
                </Button>

                <Button
                  onClick={handleLogout}
                  className="w-full justify-start gap-2 hover:bg-error/10 text-error"
                  variant="ghost"
                >
                  <Icon name="LogOut" size={18} color="#EF4444" />
                  <span>تسجيل الخروج</span>
                </Button>
              </div>
            </>
          ) : (
            <>
              {/* Change User Confirmation */}
              <div className="space-y-3">
                <div className="text-center py-2">
                  <div className="w-16 h-16 mx-auto mb-3 rounded-full bg-primary/10 flex items-center justify-center">
                    <Icon name="UserCog" size={32} color="#DAA520" />
                  </div>
                  <h4 className="text-lg font-bold text-foreground mb-2">تغيير المستخدم</h4>
                  <p className="text-sm text-muted-foreground">
                    سيتم تسجيل خروجك من الحساب الحالي والعودة إلى شاشة تسجيل الدخول
                  </p>
                </div>

                <div className="flex gap-2">
                  <Button
                    onClick={handleChangeUser}
                    className="flex-1 bg-primary hover:bg-primary/90"
                  >
                    تأكيد
                  </Button>
                  <Button
                    onClick={() => setShowChangeUser(false)}
                    variant="outline"
                    className="flex-1"
                  >
                    إلغاء
                  </Button>
                </div>
              </div>
            </>
          )}
        </div>

        {/* Powered By Footer */}
        <div className="p-3 border-t border-border bg-muted/30 flex items-center justify-center gap-2">
          <span className="text-xs text-muted-foreground">Powered by</span>
          <Image
            src="/assets/images/k-icon-tiny-1768207136633.png"
            alt="Powered by logo"
            className="h-4 w-auto object-contain"
          />
        </div>
      </div>
    </>
  );
};

export default UserProfilePopup;